import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header-anon',
  templateUrl: './header-anon.component.html',
  styleUrls: ['./header-anon.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderAnonComponent implements OnInit {

  showLogin = true;
  companyName;
  backgroundColor;
  logoDark;

  constructor() { }

  ngOnInit(): void {
    this.companyName = environment.companyName;
    this.showLogin = window.location.href.indexOf('bounce') < 0;
    this.backgroundColor =  environment.headerBackgroundColor;
    this.logoDark =  environment.logoDark;
  }

}
